<template>
  <div class="consultate">
    <div class="content">
      <div class="left">
        <img v-if="info[0] && info[0].smallImg" :src="info[0] && info[0].smallImg" alt />
        <img v-else src="@/assets/images/apply-free-trial@2x.png" alt />
      </div>
      <div class="right">
        <p class="sub-title">完善以下信息您可以免费体验我们的产品功能，我们的顾问会在 1个工作日内与您取得联系</p>
        <!-- 20230413迭代，使用abtest分流:①.name_input表示（老）留资企业名称，不使用公司联想功能，②.name_association表示（新）留资企业名称，使用公司联想功能 -->
        <div class="input" v-if="abTestPlan === 'name_input'">
          <div class="name must" v-show="!isM">公司名称</div>
          <input
            v-model="update.company"
            maxlength="30"
            @blur="blur('company', '公司名称')"
            @input="change('company', '公司名称')"
            :class="{
              wrong: wrongcompany,
            }"
            :placeholder="isM ? '公司名称' : ''"
            type="text"
          />
          <div v-show="wrongcompany" class="tip">{{ companyTip }}</div>
        </div>
        <div class="input company-position" v-else>
          <div class="name must" v-show="!isM">公司名称</div>
          <input
            v-model="update.company"
            maxlength="30"
            @blur="blur('company', '公司名称')"
            @input="() => changeInput('company', '公司名称')"
            @keyup.enter="handleAssociativeInputSearch()"
            :class="{
              wrong: wrongcompany,
            }"
            :placeholder="isM ? '公司名称' : ''"
            type="text"
          />
          <div v-show="wrongcompany" class="tip">{{ companyTip }}</div>
          <!-- 20230413：增加企业名称支持联想输入 -->
          <transition name="el-fade-in-linear">
            <div class="company-list" @click.stop v-if="companyList.length && update.company && showCompanyList">
              <p v-for="item in companyList" :key="item.certNo" @click="chooseOrg(item)" v-html="item.name"></p>
            </div>
          </transition>
        </div>
        <div class="input">
          <div class="name must" v-show="!isM">联系人姓名</div>
          <input
            maxlength="30"
            @blur="blur('userName', '联系人姓名')"
            @input="change('userName', '联系人姓名')"
            :class="{
              wrong: wronguserName,
            }"
            v-model="update.userName"
            :placeholder="isM ? '联系人姓名' : ''"
            type="text"
          />
          <div v-show="wronguserName" class="tip">{{ userNameTip }}</div>
        </div>
        <div class="input">
          <div class="name must" v-show="!isM">联系人手机号</div>
          <input
            maxlength="11"
            @blur="blur('mobile', '联系人手机号')"
            @input="change('mobile', '联系人手机号')"
            :class="{
              wrong: wrongmobile,
            }"
            v-model="update.mobile"
            :placeholder="isM ? '联系人手机号' : ''"
            type="number"
          />
          <div v-show="wrongmobile" class="tip">{{ mobileTip }}</div>
        </div>
        <div class="input">
          <div class="name must" v-show="!isM">短信验证码</div>
          <div class="code-box">
            <div class="inp" style="position: relative">
              <input
                maxlength="6"
                @blur="blur('code', '验证码')"
                :class="{
                  wrong: wrongcode,
                }"
                :placeholder="isM ? '短信验证码' : ''"
                v-model="update.code"
                class="code"
                type="number"
              />
              <div v-show="wrongcode" class="tip">{{ codeTip }}</div>
            </div>
            <button
              :disable="codeDis"
              :class="{
                disabled: codeDis,
              }"
              @click="independent_getCode"
              class="vcode"
            >
              {{ codeBtnTxt }}
            </button>
          </div>
        </div>
        <div class="input">
          <div id="man-consultate-slide"></div>
        </div>
        <div class="input">
          <div class="name" v-show="!isM">公司职务</div>
          <input type="text" :placeholder="isM ? '公司职务' : ''" />
        </div>
        <!-- <div class="input">
            <div class="is-ding">
                <button
                :class="{
                                'active':ding === 1
                            }"
                @click="ding=1"
                >钉钉用户
                <span><i class="el-icon-check"></i></span>
                </button>
                <button
                :class="{
                                'active':ding === 2
                            }"
                @click="ding=2"
                >非钉钉用户
                <span><i class="el-icon-check"></i></span>
                </button>
            </div>
            <div class="tip" v-show="wrongDing">{{ isDdTip }}</div>
        </div>-->
        <button class="submit" @click="submit">提交申请</button>
      </div>
    </div>
  </div>
</template>
<script>
import globalConfig from '@/lib/http/global-config'
import '@/mixins/form/gt.js'
import { dataRetained, getOrgList } from '@/utils'
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'consultate',
  props: ['info'],
  data() {
    return {
      timer: null,
      codeDis: false,
      originTryButtontxt: '提交试用信息',
      codeBtnTxt: '获取验证码',
      wrongcompany: false,
      wronguserName: false,
      wrongmobile: false,
      wrongcode: false,
      wrongDing: false,
      isDdTip: '选择是否为钉钉用户',
      companyTip: '',
      userNameTip: '',
      mobileTip: '',
      codeTip: '',
      isM: false,
      ding: 0,
      serviceId: null,
      update: {
        userName: '',
        company: '',
        mobile: '',
        code: '',
        chl: 'trial',
        tml: 'tsign',
        pub: '',
      },
      url: globalConfig.webServer,
      baseUrl: globalConfig.checkEsignFile,
      companyList: [], // 联想查询的公司列表
      showCompanyList: true, // 点击单个公司回显input框上，查询的公司列表消失
      takeNoteschooseOrg: false, // 记录是点击联想公司，用于埋点上报
    }
  },
  computed: {
    ...mapState('abTest', ['abTestPlan']),
  },
  watch: {
    'update.company': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.companyList = []
          this.showCompanyList = true
        }
      },
    },
  },
  created() {
    document.addEventListener('click', (e) => {
      // 点击其他区域，联想列表消失
      this.showCompanyList = false
    })
  },
  mounted() {
    if (window.innerWidth > 768) {
      this.isM = false
    } else {
      this.isM = true
    }
  },
  methods: {
    // 公司名称input框500ms延迟
    changeInput: debounce(function (code) {
      if (code === 'company' && this.update.company.length >= 30) {
        this.wrongcompany = true
        this.companyTip = '公司名称不得超过30个字'
      } else {
        this.wrongcompany = false
      }
      if (this.update.company.trim().length >= 6) {
        this.handleAssociativeInputSearch()
      }
    }, 500),
    // 输入框改变回调
    change(code, name) {
      if (code === 'company' && this.update.company.length >= 30) {
        this.wrongcompany = true
        this.companyTip = '公司名称不得超过30个字'
      } else {
        this.wrongcompany = false
      }
      if (code === 'userName' && this.update.userName.length >= 30) {
        this.wronguserName = true
        this.userNameTip = '联系人姓名不得超过30个字'
      } else {
        this.wronguserName = false
      }
      if (code === 'mobile' && !/^1[3456789]\d{9}$/.test(this.update.mobile)) {
        this.wrongmobile = true
        this.mobileTip = '手机号格式错误'
      } else {
        this.wrongmobile = false
      }
    },
    // 输入框失去焦点回调
    blur(code, name) {
      if (!this.update[code]) {
        this[`wrong${code}`] = true
        this[`${code}Tip`] = `输入${name}`
      } else {
        this[`wrong${code}`] = false
      }
      if (code === 'company' && this.update.company.length > 30) {
        this.wrongcompany = true
        this.companyTip = '公司名称不得超过30个字'
      }
      let reg = /^[\u4e00-\u9fa5_a-zA-Z]+$/
      if (code === 'company' && !reg.test(this.update.company)) {
        this.wrongcompany = true
        this.companyTip = '请输入公司名称'
      }
      if (code === 'company' && this.update.company.length < 2 && this.update.company) {
        this.wrongcompany = true
        this.companyTip = '公司名称太短'
      }
      if (code === 'userName' && !reg.test(this.update.userName)) {
        this.wronguserName = true
        this.userNameTip = '请输入您的姓名'
      }
      if (code === 'userName' && this.update.userName.length < 2 && this.update.userName) {
        this.wronguserName = true
        this.userNameTip = '姓名太短'
      }

      if (code === 'mobile' && !/^1[3456789]\d{9}$/.test(this.update.mobile)) {
        this.wrongmobile = true
        this.mobileTip = '输入正确手机号'
      }

      if (code === 'mobile' && /^1[3456789]\d{9}$/.test(this.update.mobile)) {
        this.wrongmobile = false
      }
    },
    // 获取验证码
    async fetchCode(payload = {}) {
      const num = 59
      try {
        this.codeBtnTxt = '60s后重新获取'
        this.updateCodeBtnText(num)
        await this.$axios
          .post(`${this.url}/sender/mobile/v3`, {
            bizType: 'LAND_PAGE_AUTHORIZE',
            principal: this.update.mobile,
            auth: { ...payload },
          })
          .then((res) => {
            this.serviceId = res.data.serviceId
          })
      } catch (err) {
        console.error(err)
        // alert('网络不给力，请重新尝试～')
        this.$message.error('网络不给力，请重新尝试～')
        // $('#independent_codeBtn').html('获取验证码')
        // $('#independent_codeBtn').removeClass('disabled')
        this.codeBtnTxt = '获取验证码'
        this.codeDis = false
        this.updateCodeBtnText(0)
      }
    },

    // 更新倒计时
    updateCodeBtnText(num) {
      this.timer = setInterval(() => {
        const codeBtnTxt = `${num}s后重新获取`
        this.codeBtnTxt = codeBtnTxt
        // eslint-disable-next-line no-param-reassign
        num--
        if (num < 0) {
          clearInterval(this.timer)
          this.codeBtnTxt = '获取验证码'
          this.codeDis = false
        }
      }, 1000)
    },

    // 获取验证码
    independent_getCode() {
      if (this.codeDis) return

      if (!this.update.mobile) {
        this.mobileTip = '请输入手机号'
        this.wrongmobile = true

        return
      }

      if (!/^[1][0-9][0-9]{9}$/.test(this.update.mobile)) {
        this.mobileTip = '请输入正确的手机号'
        this.wrongmobile = true

        return
      }
      this.codeDis = true

      this.invokeManMachineVerification(this.update.mobile).then((result) => {
        this.fetchCode(result)
      })
    },

    invokeManMachineVerification(currentAccount = '') {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(`${this.url}/sender/robotAuth/apply/v3`, {
            principal: currentAccount, // 当前手机号或者邮箱，即当前登录账号
            client_type: 'web',
          })
          .then((res) => {
            const { data } = res
            // 如果data不存在
            if (!data) {
              return {}
            }

            /* eslint-disable-next-line */
            return initGeetest(
              {
                product: 'bind', // 隐藏按钮式
                gt: data.gt,
                challenge: data.challenge,
                offline: !data.success,
                /* eslint-disable-next-line */
                new_captcha: data.new_captcha,
              },
              (captchaObj) => {
                // captchaObj.appendTo('#captcha-box')
                captchaObj
                  .onReady(() => {
                    // 验证码ready之后才能调用verify方法显示验证码
                    captchaObj.verify()
                  })
                  .onSuccess(() => {
                    console.log('onSuccess', this.codeDis)
                    const result = captchaObj.getValidate()
                    // @params [Object] result 包含三个参数 geetest_challenge  geetest_validate  geetest_seccode
                    resolve(result)
                  })
                  .onClose(() => {
                    console.log('onClose')
                    this.codeDis = false
                    // alert('人机校验不通过')
                    this.$message.error('人机校验不通过')
                  })
                  // eslint-disable-next-line handle-callback-err
                  .onError((err) => {
                    this.codeDis = false
                    // alert('人机校验不通过')
                    this.$message.error('人机校验不通过')
                  })
              }
            )
          })
          .catch((err) => {
            console.error(err)
            this.codeDis = false
            this.$message.error('人机校验不通过')
            // alert('人机校验不通过')

            // eslint-disable-next-line prefer-promise-reject-errors
            reject(false)
          })
      })
    },

    // eslint-disable-next-line complexity
    async submit() {
      if (!this.serviceId) {
        return alert('请先获取验证码')
      }
      const reg = /^[\u4e00-\u9fa5_a-zA-Z]+$/
      if (!this.update.company) {
        this.wrongcompany = true
        this.companyTip = '输入公司名称'

        return
      }
      if (!reg.test(this.update.company)) {
        this.wrongcompany = true
        this.companyTip = '请输入公司名称'
      }
      if (!this.update.userName) {
        this.wronguserName = true
        this.userNameTip = '输入姓名'
        return
      }
      if (this.update.company.length < 2) {
        this.wrongcompany = true
        this.companyTip = '公司名称太短'
        return
      }
      if (!reg.test(this.update.userName)) {
        this.wronguserName = true
        this.userNameTip = '请输入您的姓名'
      }
      if (this.update.userName.length < 2) {
        this.wronguserName = true
        this.userNameTip = '姓名太短'
        return
      }
      // if (this.ding === 0) {
      //   this.wrongDing = true
      //   return
      // }
      if (!this.update.mobile) {
        this.wrongmobile = true
        this.mobileTip = '输入手机号'
        return
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.update.mobile)) {
        this.wrongmobile = true
        this.mobileTip = '输入正确手机号'
        return
      }
      if (!this.update.code) {
        this.wrongcode = true
        this.codeTip = '输入验证码'
        return
      }

      this.wronguserName = false
      this.wrongcompany = false
      this.wrongDing = false
      this.wrongcompany = false
      this.wrongmobile = false
      // 校验验证码
      const res = await this.$axios.post(`${this.url}/sender/verify`, {
        credentials: this.update.code,
        serviceId: this.serviceId,
      })

      const code = +res.code
      if (code !== 0 && code !== 200) {
        return alert(res.message || '网络不给力，请重新尝试～')
      }

      try {
        // 后端数据留存
        dataRetained(this.$axios, {
          companyName: this.update.company, // 公司名称
          contactName: this.update.userName, // 联系人名称
          contactPhone: this.update.mobile, // 联系人电话
        })
        // eslint-disable-next-line camelcase
        // const orgname_source = this.orgnameSource()
        this.$tsignData.track('front_apply_trial', {
          userName: this.update.userName,
          userPhone: this.update.mobile,
          companyName: this.update.company,
          productIntention: this.$route.query.ding == 1 ? 'DING' : '', // 意向产品，值为‘DING’或者‘’
          // orgname_source: orgname_source.apply_trial_use_name, // 区分企业名称来源
          // $latest_utm_campaign: orgname_source.crm_use_name, // 用在运营支撑平台上，crm线索管理【所属活动】字段传入以上信息便于跟踪后续线索转化
        })
        this.$axios.defaults.withCredentials = true
        const res = await this.$axios.post(`${this.baseUrl}/api/server/addQuotation`, {
          userName: this.update.userName,
          companyName: this.update.company,
          mobile: this.update.mobile,
        })
        if (!res.succ) {
          this.wrongcode = true
          this.codeTip = res.msg
          this.codeDis = false
          this.codeBtnTxt = '获取验证码'
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = ''
          }
          return
        }
        alert('恭喜您申请成功，请耐心等待客服联系！')
        this.update.userName = ''
        this.update.company = ''
        this.update.mobile = ''
        this.update.code = ''
        this.update.userName = ''
        this.update.pub = ''
        this.takeNoteschooseOrg = false // 置为默认状态：是用户手动输入的，没有点击联想列表中的数据
      } catch (error) {
        console.log(error)
      }
    },
    // 20230416迭代中，增加企业名称支持联想输入
    async handleAssociativeInputSearch() {
      // 去掉首尾空格
      this.update.company = this.update.company.replace(/^\s+|\s+$/g, '')
      // 发送搜索请求
      const { data, code } = await getOrgList(this.$axios, this.update.company)
      if (code === 0) {
        this.companyList = data.orgInfos
      }
    },
    // 点击单个公司，回填到input框中
    chooseOrg(data) {
      this.update.company = data.name
      this.showCompanyList = false // 联想列表关闭
      this.takeNoteschooseOrg = true // 是点击联想列表中数据
    },
    // 区分企业名称来源，用于埋点上报
    orgnameSource() {
      /**
       * 分三种情况：
       * 1、公司名称仅输入不支持联想
       * 2、公司名称联想列表勾选（用户从联想的下拉列表中选择了公司）
       * 3、公司名称联想列表未勾选（有联想的下拉列表，但是用户仍然手动输入）
       * 其中，第一条是走的abtest中（老）留资企业名称，第二、第三条是走的abtest中（新）留资企业名称
       */
      if (this.abTestPlan === 'name_input') {
        // 表示（老）留资企业名称
        return {
          apply_trial_use_name: 'orgname_input', // apply_trial_use_name用在神策上查询
          crm_use_name: '名称仅输入不支持联想', // crm_use_name用在运营支撑平台上，crm线索管理【所属活动】字段传入以上信息便于跟踪后续线索转化
        }
      }
      // name_association，表示（新）留资企业名称
      if (this.takeNoteschooseOrg) {
        // 用户点击了联想里的企业
        return {
          apply_trial_use_name: 'orgname_association_select',
          crm_use_name: '名称联想列表勾选',
        }
      }

      // 有联想企业，但仍然手动输入
      return {
        apply_trial_use_name: 'orgname_association_not_selected',
        crm_use_name: '名称联想列表未勾选',
      }
    },
  },
}
</script>
<style lang="less" scoped>
/* 谷歌 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

/* 火狐 */
input {
  -moz-appearance: textfield;
}

.consultate {
  .content {
    max-width: 1336px;
    margin: 0 auto;
    padding: 56px 88px 56px 114px;
    overflow: hidden;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;

    .left {
      width: calc(100% - 400px);
      img {
        width: 80%;
        max-width: 540px;
        height: auto;
      }
    }
    .right {
      width: 400px;
      margin-left: 20px;

      .sub-title {
        font-size: 14px;
        font-weight: 400;
        color: rgba(32, 38, 64, 1);
        line-height: 24px;
        margin-bottom: 20px;
      }

      .code-box {
        display: flex;
        justify-content: space-between;
        .inp {
          width: 65%;
          input.code {
            width: 100%;
          }
        }
      }

      .input {
        margin-bottom: 20px;
        // overflow: hidden;

        .is-ding {
          display: flex;
          // width: 240px;

          button {
            width: 50%;
            line-height: 40px;
            color: #ccc;
            color: #202640;
            position: relative;
            background: #fff;
            font-size: 16px;
            transition: all 0.1s linear;

            &.active {
              font-weight: 600;

              span {
                background: linear-gradient(135deg, transparent 0%, transparent 50%, #e61717 50%, #e61717 100%);
              }
            }

            span {
              width: 30px;
              height: 30px;
              position: absolute;
              bottom: 0;
              right: 0;
              color: #fff;
              background: linear-gradient(135deg, transparent 0%, transparent 50%, #e8e8ed 50%, #e8e8ed 100%);
              line-height: 40px;
              text-align: right;
              padding-right: 1px;
            }
          }
        }

        .name {
          font-size: 14px;
          font-weight: 400;
          color: #202640;
          line-height: 20px;
          margin-bottom: 6px;

          &.must::before {
            content: '*';
            display: inline;
            color: #e61717;
            font-size: 22px;
            font-weight: 700;
            position: relative;
            top: 6px;
            padding-right: 3px;
          }
        }

        input {
          display: block;
          width: 100%;
          height: 40px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(218, 223, 230, 1);
          outline: unset;
          overflow: hidden;
          padding-left: 10px;
          padding-right: 10px;
          font-size: 14px;

          &.code {
            width: 65%;
            // float: left;
          }

          &.wrong {
            border-color: rgba(230, 23, 23, 1);
          }
        }

        .vcode {
          width: 35%;
          height: 40px;
          // float: right;
          color: #0975e1;

          height: 40px;
          background: #efefef;
          border-radius: 2px;

          &.disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }

        .tip {
          height: 0;
          font-size: 12px;
          font-weight: 400;
          color: rgba(230, 23, 23, 1);
          line-height: 20px;
          text-align: left;
          // margin-top: 3px;
        }
      }
      .company-position {
        position: relative;
        .company-list {
          position: absolute;
          top: 72px;
          width: 392px;
          line-height: 28px;
          max-height: 175px;
          overflow-y: auto;
          background: #fff;
          z-index: 1;
          padding: 10px;
          font-size: 14px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          p:hover {
            cursor: pointer;
            background: #f3f3f3;
          }
        }
        .company-list::-webkit-scrollbar {
          width: 8px;
          height: 1px;
        }
        .company-list::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #c0bfbf;
          box-shadow: inset 0 0 5px #eae8e8;
        }
        .company-list::-webkit-scrollbar-track {
          border-radius: 10px;
          background: #ededed;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
        }
      }
      .submit {
        display: block;
        width: 100%;
        height: 40px;
        background-color: #e61717;
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}

@media (max-width: 768px) {
  .consultate {
    padding: 0px 5%;
    min-height: 100vh;

    .title {
      font-size: 20px;
      line-height: 24px;
      font-weight: bold;
      text-align: left;
      margin-bottom: 10px;
    }

    .content {
      padding: 0;
      background: unset;
      box-shadow: none;
      -webkit-box-orient: vertical;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;

      .left {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .right {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;

        .sub-title {
          font-size: 14px;
          font-weight: 400;
          color: rgba(32, 38, 64, 1);
          line-height: 24px;
          margin-bottom: 20px;
        }

        .code-box {
          display: flex;
          justify-content: space-between;
        }

        .submit {
          display: block;
          width: 100%;
          height: 40px;
          background-color: #e61717;
          color: #fff;
          text-align: center;
          line-height: 40px;
        }
      }
    }
  }
}
</style>
